<div class="container-fluid">
  <div class="invoiceWrapper">
    <div class="row">
      <div class="col-lg-1"></div>
      <div class="col-lg-10">
        <div class="card">
          <div class="card-body">
            <div class="headerWrapper">
              <h4> User Roles </h4>
              <div class="buttonWrapper">
                <button *ngIf="addPermission === true" (click)="openDialog()" class="btn btn-success btn-sm" mat-raised-button>
                  <i aria-hidden="true" class="fa fa-plus"></i>ADD NEW
                </button>
                <button *ngIf="editPermission === true" (click)="editDialog(selectedIndex)" class="btn btn-warning btn-sm"><i
                  aria-hidden="true"
                  class="fa fa-pencil-square-o"></i>EDIT
                </button>
                <button *ngIf="deletePermission === true" (click)="deleteDialog(selectedIndex)" class="btn btn-danger btn-sm">
                  <i aria-hidden="true" class="fa fa-trash"></i>DELETE
                </button>
              </div>
            </div>
            <table class="table table-bordered" *ngIf="viewPermission === true">
              <thead>
              <tr>
                <th scope="col">Name</th>
              </tr>
              </thead>
              <tbody>
              <tbody>
              <tr (click)="selectRow(i)"
                  (dblclick)="openEditDialog(selectedIndex)"
                  *ngFor="let in of user_roles | paginate: { id: 'stockPageId', itemsPerPage: per_page, currentPage: current_page, totalItems: total_count}; let i = index; let isFirst= first" [ngClass]="{'sel': i === selectedIndex }"
                  style="height: 36px;">
                <td class="col8">{{in.name}}</td>
              </tr>
              </tbody>
            </table>
            <div class="footerWrapper row">
              <div class="col-lg-7 col-md-12 col-sm-12">
                <div class="input-group">
                  <select name="searchBy" [(ngModel)]="searchBy" data-show-content="true"
                          class="form-control border" (change)="getSearchValue()">
                    <option name="bodyNoName" value="0"> Search by User Name</option>
                  </select>
                  <input type="text" placeholder="Search" class="form-control"
                         name="searchTxt" [(ngModel)]="searchTxt" [placeholder]="placeHolder">

                  <span class="input-group-text" (click)="doSearch()">
                      <i class="fa fa-search" aria-hidden="true"></i>
                  </span>
                  <span class="input-group-text" (click)="doRefresh()">
                      <i class="fa fa-refresh" aria-hidden="true"></i>
                  </span>                   
                </div>
              </div>
              <div class="col-lg-5 col-md-12 col-sm-12">
                <app-common-page [id]="stockPageId" (pageChange)="doPaginate($event)">
                </app-common-page>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-1"></div>
    </div>
  </div>
</div>

